import { type Region, isHoliday } from "feiertagejs"

function getBusinessHoursElement(weekName: string): HTMLElement | null {
    return document.querySelector(
        `#oeffnungszeiten .opening-${weekName.toLowerCase()}, #zeiten .opening-${weekName.toLowerCase()}`,
    ) as HTMLElement | null
}

export function initBusinessHours(): void {
    const todayContent: NodeListOf<HTMLElement> = document.querySelectorAll(
        ".opening-today-container",
    ) as NodeListOf<HTMLElement>
    if (!todayContent.length) {
        return
    }

    const geoRegion = document.querySelector('meta[name="geo.region"]') as HTMLMetaElement | null
    let advertState: string = geoRegion?.content?.replace("DE-", "") || ""

    if (advertState === "" || advertState === "DE" || advertState === "AT" || advertState === "CH") {
        advertState = "BUND"
    }

    const currentDate = new Date()
    let weekName = "Feiertag"

    if (!isHoliday(currentDate, advertState as Region)) {
        weekName = new Intl.DateTimeFormat("de-DE", { timeZone: "Europe/Berlin", weekday: "long" }).format(currentDate)
    }

    const weekDayElement: string = getBusinessHoursElement(weekName)?.innerText || ""

    if (!weekDayElement) {
        return
    }

    const parser = new DOMParser()
    const businessHoursToday: HTMLElement | null = parser.parseFromString(
        `<span>Heute <strong>${weekDayElement}<strong></span>`,
        "text/html",
    ).body.firstElementChild as HTMLElement | null

    if (businessHoursToday === null) {
        return
    }

    Array.from(todayContent).map((element: HTMLElement): void => {
        element.appendChild(businessHoursToday.cloneNode(true))
    })
}
